import {defineStore} from 'pinia'
import {useApiRequestStore} from '../../ApiRequestStore/useApiRequestStore'
import {
  ICreateWorkspaceRequestInterfaces,
} from '@toolify/server/src/controllers/WorkspaceController/validators/CreateWorkspace/types/ICreateWorkspaceRequestInterfaces'
import {
  IGetWorkspaceByNameRequestInterfaces,
} from '@toolify/server/src/controllers/WorkspaceController/validators/GetWorkspaceByName/types/IGetWorkspaceByNameRequestInterfaces'
import {WorkspaceType} from '@toolify/server/src/models/mongoose/WorkspaceModel/enum/WorkspaceType'
import {
  IUpdateWorkspaceRequestInterfaces,
} from '@toolify/server/src/controllers/WorkspaceController/validators/UpdateWorkspace/types/IUpdateWorkspaceRequestInterfaces'
import {
  IDeleteWorkspaceRequestInterfaces,
} from '@toolify/server/src/controllers/WorkspaceController/validators/DeleteWorkspace/types/IDeleteWorkspaceRequestInterfaces'
import {
  IUpdateWorkspaceLogoRequestInterfaces,
} from '@toolify/server/src/controllers/WorkspaceController/validators/UpdateWorkspaceLogo/types/IUpdateWorkspaceLogoRequestInterfaces'
import {
  IExportTemplateRequestInterfaces,
} from '@toolify/server/src/controllers/WorkspaceController/validators/ExportTemplate/types/IExportTemplateRequestInterfaces'
import {
  IImportTemplateRequestInterfaces,
} from '@toolify/server/src/controllers/WorkspaceController/validators/ImportTemplate/types/IImportTemplateRequestInterfaces'
import {
  ISaveTemplateRequestInterfaces,
} from '@toolify/server/src/controllers/WorkspaceController/validators/SaveTemplate/types/ISaveTemplateRequestInterfaces'
import {
  IGetTemplatesRequestInterfaces,
} from '@toolify/server/src/controllers/WorkspaceController/validators/GetTemplates/types/IGetTemplatesRequestInterfaces'
import {
  IDeleteTemplateRequestInterfaces,
} from '@toolify/server/src/controllers/WorkspaceController/validators/DeleteTemplate/types/IDeleteTemplateRequestInterfaces'
import {
  IGetTemplateDetailRequestInterfaces,
} from '@toolify/server/src/controllers/WorkspaceController/validators/GetTemplateDetail/types/IGetTemplateDetailRequestInterfaces'
import {
  IGenerateTemplateRequestInterfaces,
} from '@toolify/server/src/controllers/WorkspaceController/validators/GenerateTemplate/types/IGenerateTemplateRequestInterfaces'
import {
  IGetResourceTreeRequestInterfaces,
} from '@toolify/server/src/controllers/WorkspaceController/validators/GetResourceTree/types/IGetResourceTreeRequestInterfaces'
import {IGetWorkspaceUsageRequestInterfaces} from '@toolify/server/src/controllers/WorkspaceController/validators/GetUsage/types/IGetWorkspaceUsageRequestInterfaces'
import {IGetWorkspaceUsageEventsRequestInterfaces} from '@toolify/server/src/controllers/WorkspaceController/validators/GetUsageEvents/types/IGetWorkspaceUsageEventsRequestInterfaces'
import {ResourceType} from '@toolify/server/src/models/mongoose/PermissionModel/enum/ResourceType'
import {ITemplateResource} from '@toolify/server/src/services/DatabaseTemplateService/types/ITemplateResource'
import {mapUsageEventResponseInstance} from '@toolify/client/src/modules/api/singletons/mapUsageEventResponseInstance'
import {mapWorkspaceUsageResponse} from '@toolify/client/src/modules/api/singletons/mapWorkspaceUsageResponse'
import {
  IUpdateWorkspaceOnboardingCompanyInfoRequestInterfaces,
} from '@toolify/server/src/controllers/WorkspaceController/validators/UpdateWorkspaceOnboardingCompanyInfo/types/IUpdateWorkspaceOnboardingCompanyInfoRequestInterfaces'
import {
  IUpdateWorkspaceOnboardingCoreAreasRequestInterfaces,
} from '@toolify/server/src/controllers/WorkspaceController/validators/UpdateWorkspaceOnboardingCoreAreas/types/IUpdateWorkspaceOnboardingCoreAreasRequestInterfaces'
import {
  IUpdateWorkspaceOnboardingSolutionsRequestInterfaces,
} from '@toolify/server/src/controllers/WorkspaceController/validators/UpdateWorkspaceOnboardingSolutions/types/IUpdateWorkspaceOnboardingSolutionsRequestInterfaces'
import {
  ISkipWorkspaceOnboardingStepRequestInterfaces,
} from '@toolify/server/src/controllers/WorkspaceController/validators/SkipWorkspaceOnboardingStep/types/ISkipWorkspaceOnboardingStepRequestInterfaces'
import {OnboardingEmployeeRangeType} from '@toolify/server/src/models/mongoose/WorkspaceModel/enum/OnboardingEmployeeRangeType'
import {OnboardingTeamRangeType} from '@toolify/server/src/models/mongoose/WorkspaceModel/enum/OnboardingTeamRangeType'
import {OnboardingCompanyCoreAreaType} from '@toolify/server/src/models/mongoose/WorkspaceModel/enum/OnboardingCompanyCoreAreaType'
import {OnboardingSolutionType} from '@toolify/server/src/models/mongoose/WorkspaceModel/enum/OnboardingSolutionType'
import {OnboardingStepType} from '@toolify/server/src/enum/OnboardingStepType'
import {LocaleType} from '@toolify/server/src/services/UserSettingsService/strategies/LocaleUserSettingStrategy/enum/LocaleType'
import {IPendingOnboardingPlan} from '@toolify/server/src/models/mongoose/WorkspaceModel/types/IPendingOnboardingPlan'
import {
  IGenerateWorkspaceOnboardingPlanRequestInterfaces,
} from '@toolify/server/src/controllers/WorkspaceController/validators/GenerateWorkspaceOnboardingPlan/types/IGenerateWorkspaceOnboardingPlanRequestInterfaces'
import {
  IUpdateWorkspaceOnboardingPlanRequestInterfaces,
} from '@toolify/server/src/controllers/WorkspaceController/validators/UpdateWorkspaceOnboardingPlan/types/IUpdateWorkspaceOnboardingPlanRequestInterfaces'
import {
  IGetWorkspaceTrashItemsRequestInterfaces,
} from '@toolify/server/src/controllers/WorkspaceTrashController/validators/GetWorkspaceTrashItems/types/IGetWorkspaceTrashItemsRequestInterfaces'
import {
  IRestoreWorkspaceTrashItemRequestInterfaces,
} from '@toolify/server/src/controllers/WorkspaceTrashController/validators/RestoreWorkspaceTrashItem/types/IRestoreWorkspaceTrashItemRequestInterfaces'
import {
  IRestoreWorkspaceTrashItemsRequestInterfaces,
} from '@toolify/server/src/controllers/WorkspaceTrashController/validators/RestoreWorkspaceTrashItems/types/IRestoreWorkspaceTrashItemsRequestInterfaces'
import {WorkspaceTrashItemType} from '@toolify/server/src/controllers/WorkspaceTrashController/enum/WorkspaceTrashItemType'
import {
  IWorkspaceTrashItemResponseInstance,
} from '@toolify/server/src/controllers/WorkspaceTrashController/types/IWorkspaceTrashItemResponseInstance'

export const useWorkspaceApiStore = defineStore('workspaceApi', {
  actions: {
    async getWorkspaceByName(workspaceName: string): Promise<IGetWorkspaceByNameRequestInterfaces['response']> {
      const apiRequestStore = useApiRequestStore()
      return await apiRequestStore.get<IGetWorkspaceByNameRequestInterfaces>(`/workspace/${workspaceName}`)
    },

    async getWorkspaceTrashItems(
      workspaceId: string,
      offset: number,
      limit: number,
      deletedRange?: [Date, Date] | null,
      resourceTypes?: ResourceType[],
    ): Promise<{
      trashItems: IWorkspaceTrashItemResponseInstance[]
      availableResourceTypes: ResourceType[]
      hasMore: boolean
    }> {
      const apiRequestStore = useApiRequestStore()
      const {trashItems, availableResourceTypes, hasMore} = await apiRequestStore.get<IGetWorkspaceTrashItemsRequestInterfaces>(`/workspace/${workspaceId}/trash-items`, {
        params: {
          offset,
          limit,
          ...(deletedRange && {
            deletedFrom: deletedRange[0].toISOString(),
            deletedTo: deletedRange[1].toISOString(),
          }),
          ...(resourceTypes?.length && {resourceTypes}),
        },
      })
      return {
        trashItems: trashItems.map(trashItem => ({
          trashItemType: trashItem.trashItemType,
          resourceType: trashItem.resourceType,
          resourceId: trashItem.resourceId,
          resourceItemId: trashItem.resourceItemId,
          name: trashItem.name,
          parentName: trashItem.parentName,
          spaceName: trashItem.spaceName,
          deletedAt: new Date(trashItem.deletedAt),
          deletedBy: trashItem.deletedBy as IWorkspaceTrashItemResponseInstance['deletedBy'],
        })),
        availableResourceTypes,
        hasMore,
      }
    },

    async restoreWorkspaceTrashItem(
      workspaceId: string,
      trashItemType: WorkspaceTrashItemType,
      resourceId: string,
      includeItems?: boolean,
    ): Promise<void> {
      const apiRequestStore = useApiRequestStore()
      await apiRequestStore.post<IRestoreWorkspaceTrashItemRequestInterfaces>(`/workspace/${workspaceId}/trash-items/restore`, {
        data: {
          trashItemType,
          resourceId,
          ...(includeItems !== undefined && {includeItems}),
        },
      })
    },

    async restoreWorkspaceTrashItems(
      workspaceId: string,
      options: {
        trashItems?: {trashItemType: WorkspaceTrashItemType, resourceId: string}[]
        all?: boolean
        deletedRange?: [Date, Date] | null
        resourceTypes?: ResourceType[]
      },
    ): Promise<IRestoreWorkspaceTrashItemsRequestInterfaces['response']> {
      const apiRequestStore = useApiRequestStore()
      return await apiRequestStore.post<IRestoreWorkspaceTrashItemsRequestInterfaces>(`/workspace/${workspaceId}/trash-items/restore-many`, {
        data: {
          ...(options.all
            ? {all: true}
            : {trashItems: options.trashItems}),
          ...(options.deletedRange && {
            deletedFrom: options.deletedRange[0].toISOString(),
            deletedTo: options.deletedRange[1].toISOString(),
          }),
          ...(options.resourceTypes?.length && {resourceTypes: options.resourceTypes}),
        },
      })
    },

    async createWorkspace(
      name: string,
      title: string,
      type: WorkspaceType,
    ): Promise<ICreateWorkspaceRequestInterfaces['response']> {
      const apiRequestStore = useApiRequestStore()
      return await apiRequestStore.post<ICreateWorkspaceRequestInterfaces>('/workspace', {
        data: {
          name,
          title,
          type,
        },
      })
    },

    async updateWorkspace(
      id: string,
      name: string,
      title: string,
      dateFormat: string,
      type: WorkspaceType,
    ): Promise<ICreateWorkspaceRequestInterfaces['response']> {
      const apiRequestStore = useApiRequestStore()
      return await apiRequestStore.patch<IUpdateWorkspaceRequestInterfaces>(`/workspace/${id}`, {
        data: {
          name,
          title,
          type,
          dateFormat,
        },
      })
    },

    async deleteWorkspace(
      id: string,
    ): Promise<IDeleteWorkspaceRequestInterfaces['response']> {
      const apiRequestStore = useApiRequestStore()
      return await apiRequestStore.delete<IDeleteWorkspaceRequestInterfaces>(`/workspace/${id}`)
    },

    async updateLogo(workspaceId: string, file: File|Blob): Promise<IUpdateWorkspaceLogoRequestInterfaces['response']> {
      const apiRequestStore = useApiRequestStore()
      const formData = new FormData()
      formData.append('file', file)
      return await apiRequestStore.put<IUpdateWorkspaceLogoRequestInterfaces>(`/workspace/${workspaceId}/logo`, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        data: formData,
      })
    },
    // async inviteUserToWorkspaceByMail(workspaceName: string, mail: string): Promise<unknown> {
    //   const apiRequestStore = useApiRequestStore()
    //   return await apiRequestStore.post(`/workspace/${workspaceName}/invite`, {
    //     data: {
    //       mail,
    //     },
    //   })
    // },

    async exportTemplate(
      workspaceId: string,
      resources: Array<{resourceType: ResourceType, resourceId: string}>,
      excludedResources?: Array<{resourceType: ResourceType, resourceId: string}>,
      excludedResourceTypes?: ResourceType[],
    ): Promise<IExportTemplateRequestInterfaces['response']> {
      const apiRequestStore = useApiRequestStore()
      return await apiRequestStore.post<IExportTemplateRequestInterfaces>(`/workspace/${workspaceId}/export-template`, {
        data: {
          resources,
          excludedResources,
          excludedResourceTypes,
        },
      })
    },

    async getResourceTree(
      workspaceId: string,
      query: IGetResourceTreeRequestInterfaces['query'] = {},
    ): Promise<IGetResourceTreeRequestInterfaces['response']> {
      const apiRequestStore = useApiRequestStore()
      return await apiRequestStore.get<IGetResourceTreeRequestInterfaces>(`/workspace/${workspaceId}/resource-tree`, {
        params: query,
      })
    },

    async getUsage(
      workspaceId: string,
      from?: string | null,
      to?: string | null,
      timeZone?: string | null,
    ): Promise<IGetWorkspaceUsageRequestInterfaces['response']> {
      const apiRequestStore = useApiRequestStore()
      const response = await apiRequestStore.get<IGetWorkspaceUsageRequestInterfaces>(`/workspace/${workspaceId}/usage`, {
        params: {
          ...(from ? {from} : {}),
          ...(to ? {to} : {}),
          ...(timeZone ? {timeZone} : {}),
        },
      })
      return mapWorkspaceUsageResponse(response)
    },

    async getUsageEvents(
      workspaceId: string,
      offset: number,
      limit: number,
      from?: string | null,
      to?: string | null,
    ): Promise<IGetWorkspaceUsageEventsRequestInterfaces['response']> {
      const apiRequestStore = useApiRequestStore()
      const response = await apiRequestStore.get<IGetWorkspaceUsageEventsRequestInterfaces>(`/workspace/${workspaceId}/usage-events`, {
        params: {
          offset,
          limit,
          ...(from ? {from} : {}),
          ...(to ? {to} : {}),
        },
      })

      return {
        ...response,
        usageEvents: response.usageEvents.map(usageEvent => mapUsageEventResponseInstance(usageEvent)),
      }
    },

    async importTemplate(
      workspaceId: string,
      templates: ITemplateResource[],
      targetResourceType: ResourceType,
      targetResourceId: string,
      importId?: string,
    ): Promise<IImportTemplateRequestInterfaces['response']> {
      const apiRequestStore = useApiRequestStore()
      return await apiRequestStore.post<IImportTemplateRequestInterfaces>(`/workspace/${workspaceId}/import-template`, {
        data: {
          templates,
          targetResourceType,
          targetResourceId,
          importId,
        },
      })
    },

    async saveTemplate(
      workspaceId: string,
      name: string,
      description: string | undefined,
      resources: Array<{resourceType: ResourceType, resourceId: string}>,
      excludedResources?: Array<{resourceType: ResourceType, resourceId: string}>,
      excludedResourceTypes?: ResourceType[],
      options?: {category?: string, tags?: string[], templateId?: string, visibility?: string},
    ): Promise<ISaveTemplateRequestInterfaces['response']> {
      const apiRequestStore = useApiRequestStore()
      return await apiRequestStore.post<ISaveTemplateRequestInterfaces>(`/workspace/${workspaceId}/templates`, {
        data: {
          name,
          description,
          resources,
          excludedResources,
          excludedResourceTypes,
          category: options?.category,
          tags: options?.tags,
          templateId: options?.templateId,
          visibility: options?.visibility,
        },
      })
    },

    async deleteTemplate(
      workspaceId: string,
      templateId: string,
    ): Promise<IDeleteTemplateRequestInterfaces['response']> {
      const apiRequestStore = useApiRequestStore()
      return await apiRequestStore.delete<IDeleteTemplateRequestInterfaces>(
        `/workspace/${workspaceId}/templates/${templateId}`,
      )
    },

    async getTemplates(workspaceId: string): Promise<IGetTemplatesRequestInterfaces['response']> {
      const apiRequestStore = useApiRequestStore()
      return await apiRequestStore.get<IGetTemplatesRequestInterfaces>(`/workspace/${workspaceId}/templates`)
    },

    async getTemplateDetail(
      workspaceId: string,
      templateId: string,
    ): Promise<IGetTemplateDetailRequestInterfaces['response']> {
      const apiRequestStore = useApiRequestStore()
      return await apiRequestStore.get<IGetTemplateDetailRequestInterfaces>(
        `/workspace/${workspaceId}/templates/${encodeURIComponent(templateId)}`,
      )
    },

    async generateTemplate(
      workspaceId: string,
      data: IGenerateTemplateRequestInterfaces['body'],
    ): Promise<IGenerateTemplateRequestInterfaces['response']> {
      const apiRequestStore = useApiRequestStore()
      return await apiRequestStore.post<IGenerateTemplateRequestInterfaces>(
        `/workspace/${workspaceId}/templates/generate`,
        {data},
      )
    },

    async createWorkspaceAppAccessRequest(
      workspaceId: string,
      appId: string,
      requestedScopes: string[],
    ): Promise<void> {
      const apiRequestStore = useApiRequestStore()
      await apiRequestStore.post(`/workspaces/${workspaceId}/apps/${appId}/access-request`, {
        data: {
          requested_scopes: requestedScopes,
        },
      })
    },

    async installWorkspaceApp(
      workspaceId: string,
      appId: string,
    ): Promise<{result: 'installed' | 'requested'}> {
      const apiRequestStore = useApiRequestStore()
      return await apiRequestStore.post<{response: {result: 'installed' | 'requested'}}>(
        `/workspaces/${workspaceId}/apps/${appId}/install`,
        {
          data: {},
        },
      )
    },

    async uninstallWorkspaceApp(workspaceId: string, appId: string): Promise<void> {
      const apiRequestStore = useApiRequestStore()
      await apiRequestStore.delete(`/workspaces/${workspaceId}/apps/${appId}/install`)
    },

    async createWorkspaceAppInstallRequest(
      workspaceId: string,
      clientId: string,
      requestedScopes: string[],
    ): Promise<void> {
      const apiRequestStore = useApiRequestStore()
      await apiRequestStore.post(`/workspaces/${workspaceId}/install-request`, {
        data: {
          client_id: clientId,
          requested_scopes: requestedScopes,
        },
      })
    },

    async getWorkspaceInstalledApps(workspaceId: string): Promise<{apps: unknown[]}> {
      const apiRequestStore = useApiRequestStore()
      return await apiRequestStore.get<{response: {apps: unknown[]}}>(`/workspaces/${workspaceId}/installed-apps`)
    },

    async getWorkspaceAppAccessRequests(workspaceId: string): Promise<{requests: unknown[]}> {
      const apiRequestStore = useApiRequestStore()
      return await apiRequestStore.get<{response: {requests: unknown[]}}>(`/workspaces/${workspaceId}/app-access-requests`)
    },

    async approveWorkspaceAppAccessRequest(requestId: string): Promise<void> {
      const apiRequestStore = useApiRequestStore()
      await apiRequestStore.post(`/workspace-app-access-requests/${requestId}/approve`, {
        data: {},
      })
    },

    async rejectWorkspaceAppAccessRequest(requestId: string, note?: string): Promise<void> {
      const apiRequestStore = useApiRequestStore()
      await apiRequestStore.post(`/workspace-app-access-requests/${requestId}/reject`, {
        data: note ? {note} : {},
      })
    },

    async cancelWorkspaceAppAccessRequest(requestId: string): Promise<void> {
      const apiRequestStore = useApiRequestStore()
      await apiRequestStore.post(`/workspace-app-access-requests/${requestId}/cancel`, {
        data: {},
      })
    },

    async approveWorkspacePermissionRequest(requestId: string): Promise<void> {
      const apiRequestStore = useApiRequestStore()
      await apiRequestStore.post(`/workspace-permission-requests/${requestId}/approve`, {
        data: {},
      })
    },

    async rejectWorkspacePermissionRequest(requestId: string): Promise<void> {
      const apiRequestStore = useApiRequestStore()
      await apiRequestStore.post(`/workspace-permission-requests/${requestId}/reject`, {
        data: {},
      })
    },

    async getWorkspacePermissionRequests(workspaceId: string): Promise<{requests: unknown[]}> {
      const apiRequestStore = useApiRequestStore()
      return await apiRequestStore.get<{response: {requests: unknown[]}}>(`/workspaces/${workspaceId}/permission-requests`)
    },

    async getMyWorkspacePermissionRequests(status?: string | null): Promise<{requests: unknown[]}> {
      const apiRequestStore = useApiRequestStore()
      return await apiRequestStore.get<{response: {requests: unknown[]}}>('/me/workspace-permission-requests', {
        params: status ? {status} : {},
      })
    },

    async createWorkspacePermissionRequests(data: {
      workspaceId: string
      requestedForEntities: Array<{entityType: string, entityId: string}>
      permissionType: string
      resources: Array<{resourceType: string, resourceId: string}>
      note?: string | null
    }): Promise<{requests: unknown[]}> {
      const apiRequestStore = useApiRequestStore()
      return await apiRequestStore.post<{response: {requests: unknown[]}}>('/workspace-permission-requests', {
        data,
      })
    },

    async updateOnboardingCompanyInfo(
      workspaceId: string,
      employeeRange?: OnboardingEmployeeRangeType,
      teamRange?: OnboardingTeamRangeType,
    ): Promise<void> {
      const apiRequestStore = useApiRequestStore()
      await apiRequestStore.put<IUpdateWorkspaceOnboardingCompanyInfoRequestInterfaces>(`/workspace/${workspaceId}/onboarding/company-info`, {
        data: {
          ...(employeeRange && {employeeRange}),
          ...(teamRange && {teamRange}),
        },
      })
    },

    async updateOnboardingCoreAreas(workspaceId: string, coreAreas: OnboardingCompanyCoreAreaType[]): Promise<void> {
      const apiRequestStore = useApiRequestStore()
      await apiRequestStore.put<IUpdateWorkspaceOnboardingCoreAreasRequestInterfaces>(`/workspace/${workspaceId}/onboarding/core-areas`, {
        data: {
          coreAreas,
        },
      })
    },

    async updateOnboardingSolutions(workspaceId: string, solutions: OnboardingSolutionType[]): Promise<void> {
      const apiRequestStore = useApiRequestStore()
      await apiRequestStore.put<IUpdateWorkspaceOnboardingSolutionsRequestInterfaces>(`/workspace/${workspaceId}/onboarding/solutions`, {
        data: {
          solutions,
        },
      })
    },

    async generateOnboardingPlan(
      workspaceId: string,
      prompt: string,
      locale: LocaleType,
    ): Promise<IGenerateWorkspaceOnboardingPlanRequestInterfaces['response']> {
      const apiRequestStore = useApiRequestStore()
      return await apiRequestStore.post<IGenerateWorkspaceOnboardingPlanRequestInterfaces>(
        `/workspace/${workspaceId}/onboarding/generate-plan`,
        {
          data: {
            prompt,
            locale,
          },
        },
      )
    },

    async updateOnboardingPlan(workspaceId: string, plan: IPendingOnboardingPlan): Promise<void> {
      const apiRequestStore = useApiRequestStore()
      await apiRequestStore.put<IUpdateWorkspaceOnboardingPlanRequestInterfaces>(
        `/workspace/${workspaceId}/onboarding/workspace-plan`,
        {
          data: {
            source: plan.source,
            templateId: plan.templateId,
            groups: plan.groups,
          },
        },
      )
    },

    async skipOnboardingStep(workspaceId: string, stepType: OnboardingStepType): Promise<void> {
      const apiRequestStore = useApiRequestStore()
      await apiRequestStore.put<ISkipWorkspaceOnboardingStepRequestInterfaces>(`/workspace/${workspaceId}/onboarding/skip/${stepType}`, {})
    },
  },
})
